import React, { Component } from "react";
import { Button } from "../../../common/Button/Button";
import moment from "moment";

class NotesTrailTTDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title,
    };
  }

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        window.addEventListener("click", this.close);
      } else {
        window.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close = (timeOut) => {
    this.setState({
      listOpen: false,
    });
  };

  toggleList() {
    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  }

  renderNotesTrail = () => {
    const { notesHistory = [] } = this.props;
    console.log("notesHistory", notesHistory);
     if (notesHistory.length === 0)
      return <div className=" audit-body">No notes taken</div>;

      return Object.keys(notesHistory["results"]).map((key, i) => (

          
         
        <div
              style={{paddingBottom:"5px",marginBottom:"10px",borderBottom:"1px solid lightgray"}}>
             {/* <h5>
             {`${notesHistory["results"][i].refService["sResourceDisplayName"]}`}
             {`(${notesHistory["results"][i].refService["nResourceInstanceId"]})`}
             
             </h5> */}
             {`${notesHistory["results"][i].refService["sIHHEmail"]}`}

             <span className="conv-float-right">{`${notesHistory["results"][i]["dtCreated"]?moment(notesHistory["results"][i]["dtCreated"]).format('lll'):""} `}</span>
             
            <div className="audits-body mt-2">
             <br></br>
             <span style={{fontSize:"13px"}}>Notes</span><br></br>
             {`${notesHistory["results"][i]["sNotes"]} `}
             <br></br>
             <span style={{fontSize:"13px"}}>Followup Action</span><br></br>
             {`${notesHistory["results"][i]["sFollowupAction"]} `}
             <br></br>
             <span style={{fontSize:"13px"}}>Follow up On</span><br></br>
             {`${notesHistory["results"][i]["dtFollowupOn"]?moment(notesHistory["results"][i]["dtFollowupOn"]).format('ll'):""} `}
              
            </div>


         </div>   
       
     ))
    };
    // return notesHistory.map((history, i) => {
    //   return (
    //     <div className="mt-2" key={i}>
    //       <div className="flex justify-content-between">
    //         <small>{history.reqUser}</small>
    //         <small>{moment(history.dtCreated).format("lll")}</small>
    //       </div>
    //       {history.bSPEntry?
    //       (
    //           <div className="audit-body mt-2">
    //               <div>
    //                 <small>Follow up (by Service Partner) on</small>
    //               </div>
    //               {moment(history.dtFollowupOn).format("ll")}
    //               <div>
    //                 <small>Completed</small>
    //               </div>
    //               {history.bHandled ? "Yes" : "No"}
    //           </div>      
    //       ):
    //       (
    //         <div className="audit-body mt-2">
    //         <div>
    //           <small>Notes</small>
    //         </div>
    //         {history.sNotes ? history.sNotes : history.sNotesHH}
    //         {history.sModule?(""):
    //         (
    //           <>
    //             <div>
    //               <small>Followup Actions</small>
    //             </div>
    //             {history.sFollowupAction}
    //             <div>
    //               <small>Follow up on</small>
    //             </div>
    //             {moment(history.dtFollowupOn).format("ll")}
    //             <div>
    //               <small>Completed</small>
    //             </div>
    //             {history.bHandled ? "Yes" : "No"}
    //           </>
    //         )}  
    //       </div>)}
    //     </div>
    //   );
    // });
  

  //   shouldComponentUpdate(nextProps, nextState) {
  //     if (this.state.listOpen !== nextState.listOpen) return true;
  //     if (this.props.auditLog === nextProps.auditLog) return false;
  //     return true;
  //   }

  render() {
    const { listOpen } = this.state;
    const { auditLog } = this.props;
    return (
      <div className="dd-wrapper audit">
        <div className="dd-header" onClick={() => this.toggleList()}>
          <div className="dd-header-title">
            {/* <Button>Trail</Button> */}
            <a>
            <span className="label-link conv-ml20 conv-mr10"> Trail</span>     
			</a>
          </div>
        </div>



        {listOpen && (
          <div className="dd-list notes">
            <div>{this.renderNotesTrail()}</div>
          </div>
        )}
      </div>
    );
  }
}

export default NotesTrailTTDropdown;
